export const BPU = 'bpu'
export const CPU = 'cpu'
export const HS = 'hs'
export const K8 = 'k8'
export const SELA = 'sela'
export const SETUP = 'setup'
